var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMonitorPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.1228H1.5V20.6228H22.5V19.1228Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6.38281H19.5V3.38281H18V6.38281H15V7.88281H18V10.8828H19.5V7.88281H22.5V6.38281Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54 4.70281C1.97 4.70281 1.5 5.16281 1.5 5.74281V12.2228C1.5 12.7928 1.96 13.2628 2.54 13.2628H5.56V14.4228H3.94V15.6828H10.87V14.4228H9.25V13.2628H12.27C12.84 13.2628 13.31 12.8028 13.31 12.2228V5.74281C13.31 5.17281 12.85 4.70281 12.27 4.70281H2.54ZM6.82 14.4228V13.2628H7.98V14.4228H6.82ZM12.04 5.96281V11.9928H2.76V5.96281H12.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonitorPlus);
export default __webpack_public_path__ + "static/media/ic-monitor-plus.6e53770099571c4bcd95796b71fd8376.svg";
export { ForwardRef as ReactComponent };